import { type TFunction } from 'i18next';

import { makeNumber } from './make-number';

export const formatNumber = (value: number | string | null | undefined, t: TFunction) => {
  return t('intlNumber', { value: makeNumber(value) });
};
